<app-abstract-dialog class="info-dialog"
                     [dialogWidth]="'800'">

    <ng-container abstract-header>
        <mat-icon class="abstract-dialog__header__icon material-icons-round info">
            info
        </mat-icon>
        <h3 class="abstract-dialog__header__title">{{noOfDeleted}}/{{noOfTotal}} {{'GENERAL.FILES_ARE_NOT_DELETED_TITLE' | translate}}</h3>
    </ng-container>

    <ng-container abstract-content>
        <p class="abstract-dialog__content__text">{{'GENERAL.FILES_ARE_NOT_DELETED_DESCRIPTION' | translate}}</p>
    </ng-container>

    <ng-container abstract-footer>
        <div class="abstract-dialog__footer__buttons-wrapper">
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'small outlined outlined__gray-07'"
                        [disabled]="true">
                    {{'GENERAL.SHOW_REFERENCES' | translate }}
                </app-button>
            </div>
            <div class="abstract-dialog__footer__buttons-wrapper__btn-box">
                <app-button
                        [cssClasses]="'small solid__blue-07'"
                        (buttonClicked)="closeDialogEvent.emit()">
                    OK
                </app-button>
            </div>
        </div>
    </ng-container>
</app-abstract-dialog>
